import PropTypes from 'prop-types';
import { memo } from 'react';

import { ClockType, GameStatusType } from '../../api/types';
import { ClockCounter, toMinutes } from '../counters/clock-counter';
import { MatchStatus } from '../match-status/match-status';

import './time-or-status.scss';

function TimeOrStatusUI({ clock, stage, status }) {
  return clock && clock.stopped !== true ? (
    <span className="sb-TimeOrStatus">
      <ClockCounter clock={clock} format={toMinutes} />
    </span>
  ) : (
    <MatchStatus stage={stage} status={status} />
  );
}

TimeOrStatusUI.propTypes = {
  clock: ClockType,
  stage: PropTypes.string,
  status: GameStatusType.isRequired,
};

TimeOrStatusUI.defaultProps = {
  clock: undefined,
  stage: undefined,
};

export const TimeOrStatus = memo(TimeOrStatusUI);
